import React, { ReactNode } from 'react';
import { ReadMore } from '../../ReadMore';
import useScreenSize from '../../../../hooks/useScreenSize';
import { SpaceSection } from '../../SpaceSection';
import { MobileBlock } from '../CurrentItemSections/styled';
import { useResponsive } from '../../../../hooks/useResponsive';

interface CurrentItemDescProps {
  title: ReactNode;
  description: ReactNode;
}

export const CurrentItemDesc: React.FC<CurrentItemDescProps> = ({
  description,
  title
}) => {
  const { showOnMobile } = useResponsive();
  const { isSmall } = useScreenSize();

  if (!isSmall && !description) return null;

  return (
    <SpaceSection>
      <div data-cy="cur-item-desc">
        {showOnMobile && <MobileBlock>{title}</MobileBlock>}
        {description && <ReadMore description={description} />}
      </div>
    </SpaceSection>
  );
};
